import { render, staticRenderFns } from "./VenueSettings.vue?vue&type=template&id=8e8aff88&scoped=true&"
import script from "./VenueSettings.vue?vue&type=script&lang=js&"
export * from "./VenueSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e8aff88",
  null
  
)

export default component.exports